// extracted by mini-css-extract-plugin
export default {"formVideoBox":"index_formVideoBox_owqy1","formVideoButton":"index_formVideoButton_5sxea","formVideoUploadInput":"index_formVideoUploadInput_lZtsn"};